import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ProjectAPI from './projectAPI';

export const listProject = createAsyncThunk('projects/list', async ({ page, username, tag }, { rejectWithValue }) => {
    try {
        const response = await ProjectAPI.listProject({ page, username, tag });
        // console.log('response.data : ', response.data)
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    projects: null,
    error: null,
    lastPage: 1,
};

const projectsSlice = createSlice({
    name: 'projects',
    initialState,
    reducers: {
        unloadProjectList: state => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(listProject.fulfilled, (state, { payload }) => {
                state.projects = payload;
                state.error = null;
            })
            .addCase(listProject.rejected, (state, { payload }) => {
                state.projects = null;
                state.error = payload;
            })
    },
});

export const { unloadProjectList } = projectsSlice.actions;
export default projectsSlice.reducer;
